
<template>
    <v-btn @click="$emit('click')" :class="`button ${type}`" :disabled="disabled" >
        <slot v-if="type"></slot>
    </v-btn>
</template>

<script>
export default {

    name: 'UiButton', 

    props:{
        submit:{
            type: Boolean,
            default: false
        },

        icon: {
            type: String,
            required: false
        },

        disabled:{
            type: Boolean,
            default: false
        },
        
        type:{
            type: String,
            default: 'main-btn'
        }
    },

}
</script>

<style>

    .button{
        transition: 1s;
        text-align: center;
        text-transform: initial;
        min-height: 44px;
        padding: 1em 2em !important;
        cursor: pointer;
        border-radius: 36px !important;
    }
    .button .v-btn__content {
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
        display: block;
    }
    
    .full-width{
        width: 100%;
    }
    .button:hover{
        transition: 1s;
    }

    .gray-btn{
        border: none;
        background: #C4C4C4 !important;
        color: #000000 !important;
        outline: none !important;
    }

    .gray-btn:hover{
        /* border: 1px solid #000000 !important; */
        color: black !important;
        /* background: white !important; */
    }
    
    .main-btn{
        border: none;
        background: #981010 !important;
        color: #FFFFFF !important;
        outline: none !important;
    }
    .main-btn:hover{
        color: #000000 !important;
        /* background: #C4C4C4 !important; */
    }

    @media (max-width: 1024px) {
        .button{
            padding: 0.4em 1.3em;
            min-height: 24px;
        }
    }
    @media (max-width: 850px) {
        .button{
           font-family: 'Helvetica';
            font-style: normal  !important;
            font-weight: 400  !important;
            font-size: 14px  !important;
            line-height: 16px  !important;
            text-align: center  !important;
            letter-spacing: 0.07em;
        }
    }
    @media (min-width: 850px) {
        .button{
            font-family: 'Helvetica';
            font-style: normal;
            font-weight: 500 !important;
            font-size: 27px !important;
            line-height: 31px;
            text-align: center;
        }
    }
    @media (max-width: 1650px) {
        .button{
            font-size: 23px  !important;
        }
    }
    @media (max-width: 1350px) {
        .button{
            font-size: 20px  !important;
        }
    }
    @media (max-width: 850px) {
        .button{
            font-family: 'Helvetica';
            font-style: normal  !important;
            font-weight: 500  !important;
            font-size: 14px  !important;
            line-height: 16px  !important;
            text-align: center  !important;
        }
    }
    
</style>



// WEBPACK FOOTER //
// UiBtn.vue?57535b4c